<template>
    <section v-if="getTableData">
        <mvtCollapse :disable="disableCollapse"  :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f4 text-bold singleline">{{molang('dpp.propertyMarket.statistics')}}</h2>
                <div class="f7 text-gray singleline" v-show="collapsible.collapsed">{{description}}</div>
            </template>
            <template v-slot:default>
            <div class="property-market grid xs-grid-cols-1">
                <div class="grid xs-grid-cols-1">
                    <ul class="tab tab-bookmark">
                        <li v-for="item in sourceTypes">
                            <a @click="changeFilterBy(item.value)" :class="{active: filterBy == item.value}" role="button"><span>{{item.text}}</span></a>
                        </li>
                    </ul>
                    <div class="property-market-info">
                        <div class="item">
                            <div>{{dpp.geo.address || '&nbsp;'}}</div>
                            <div class="f3 addressBox">
                                <b>{{getTableData.current.value}}</b>
                            </div>
                        </div>
                        <div class="item" v-if="!useCountyData">
                            <div>{{dpp.geo.neighborhood || '&nbsp;' }}</div>
                            <div class="neighborhoodBox">
                                <b>{{getTableData.neighborhood.value}}</b>
                                <span v-if="getTableData.neighborhood.rate" :class="getTableData.neighborhood.class" class="tag small">{{getTableData.neighborhood.rate}} y/y</span>
                            </div>
                        </div>
                        <div class="item" v-if="useCountyData">
                            <div>{{dpp.geo.county || '&nbsp;' }}</div>
                            <div class="neighborhoodBox">
                                <b>{{getTableData.county.value}}</b>
                                <span v-if="getTableData.county.rate" :class="getTableData.county.class" class="tag small">{{getTableData.county.rate}} y/y</span>
                            </div>
                        </div>
                        <div class ="item">
                            <div>{{dpp.geo.zipcode || '&nbsp;'}}</div>
                            <div class="zipcodeBox">
                                <b>{{getTableData.zipcode.value}}</b>
                                <span v-if="getTableData.zipcode.rate" :class="getTableData.zipcode.class" class="tag small">{{getTableData.zipcode.rate}} y/y</span>
                            </div>
                        </div>
                        <div class="item">
                            <div>{{dpp.geo.city || '&nbsp;'}}</div>
                            <div class="cityBox">
                                <b>{{getTableData.city.value}}</b>
                                <span v-if="getTableData.city.rate" :class="getTableData.city.class" class="tag small">{{getTableData.city.rate}} y/y</span>
                            </div>
                        </div>
                    </div>
                    <div class="property-market-chart" :class="{'no-chart': !chartData}">
                        <mvtChart v-if="chartData" :data="chartData"></mvtChart>
                        <template v-else>
                            {{molang('dpp.propertyMarket.noChart')}}
                        </template>
                    </div>
                    <mvtMarketTrendsCTA :geoInfo="dpp.geo"/>
                </div>
                <div id="marketTrendCompare" class="grid xs-grid-cols-1 md-grid-cols-2" v-if="compareData && compareData.length">
                    <h2 class="f4 text-bold m-t-4 wrap grid-">{{molang('dpp.propertyMarket.comparisonProperties')}}</h2>
                    <template v-for="item in compareData">
                    <div v-if="item">
                        <div class="property-bar-title">
                                {{item.title}}
                        </div>
                        <div class="property-bar">
                            <div class="min">{{item.formatMinValue}}<br>Min</div>
                            <div class="current" v-if="item.currentValue" :class="item.className" :style="{left:item.left}"> <span>{{item.formatPercentage}}</span>  {{item.formatCurrentValue}}</div>
                            <div class="mid">{{item.formatAvgValue}}<br> Avg</div>
                            <div class="max">{{item.formatMaxValue}}<br>Max</div>
                        </div>
                    </div>
                    </template>
                </div>
                <div class="paragraph f7">
                    {{molang('dpp.propertyMarket.statisticsByMovoto')}}
                </div>
                <dppCtaCard v-if="dpp.isActive" :dppCtaInfo="{title: molang('dpp.propertyMarket.ctaTitle'),
                sub: molang('dpp.propertyMarket.ctaSub'),
                cta: molang('dpp.sellbanner.connectNow'),
                icon: 'icon-graph-increasing',
                hotleadType: 'MarketStatsDPP',
                section: 'Market Statistics'}"/>
            </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-market.js"></script>

<style lang="scss">
@use "./property-market.scss" as *;
</style>
